import { IEditPincodePayload, IGetPincodeList, IPincodeCreate, IPincodeDetails, IPincodeListSearch, IPincodeSearch } from "../../../types/master/pincodeInterface";
import { PincodeActionTypes, PincodeActions } from "../../actionTypes/master/pincodeActionTypes";

export const createPincode = (payload: IPincodeCreate): PincodeActionTypes => ({
  type: PincodeActions.CREATE_PINCODE,
  payload,
});

export const getPincodeList = (payload: IPincodeListSearch): PincodeActionTypes => ({
  type: PincodeActions.GET_PINCODE_LIST,
  payload,
});

export const setPincodeList = (branchList: Array<IGetPincodeList>) : PincodeActionTypes => ({
  type: PincodeActions.SET_PINCODE_LIST,
  payload: branchList
})

export const setPincodeListPageCount = (payload: number): PincodeActionTypes => ({
  type: PincodeActions.SET_PINCODE_LIST_PAGE_COUNT,
  payload
})

export const getPincodeDataByPincode = (payload: IPincodeSearch): PincodeActionTypes => ({
  type: PincodeActions.GET_PINCODE_DATA_BY_PINCODE,
  payload
})



export const setPincodeDataByPincode = (payload: IPincodeDetails) => ({
  type: PincodeActions.SET_PINCODE_DATA_BY_PINCODE,
  payload
})

export const editPincode = (payload: IEditPincodePayload) => ({
  type: PincodeActions.EDIT_PINCODE_DATA_BY_PINCODE,
  payload,
});
